import React, { useState } from "react";
import Tabs from "../../../components/ACS-Dashboard/ACS-Blocks/Tabs";
import { useSelector, useDispatch } from "react-redux";
import {
  addTab,

  removeTab,
  setActiveTab,
} from "../../../redux/slices/locationSlice";
import { selectModuleTabs } from "../../../redux/selectors/tabsSelectors";
import { FiSearch } from "react-icons/fi";
import LocationsTable from "./LocationsTable";
import ViewLocation from "./ViewLocation";
import Button from "../../../components/ACS-Dashboard/ACS-Blocks/Button";
import CreateLocationTab from "../Manage-Team/TabContent/CreateLocationTab";
import BulkUpdateLocationsTab from "./BulkUpdate/BulkUpdateLocationsTab";
import notify from "../../../components/ACS-Dashboard/ACS-Blocks/Toast";


const moduleName = "locations";

const LocationsDetails = () => {
  const dispatch = useDispatch();
  const { tabs, activeTab, defaultTabsCount } = useSelector(
    selectModuleTabs(moduleName)
  );

  const [searchQuery, setSearchQuery]       = useState("");
  const [totalLocations, setTotalLocations] = useState(0);

  const handleRemoveTab = (index) => {
    if (index < defaultTabsCount) return;
    dispatch(removeTab({ module: moduleName, tabIndex: index }));
  };

  const handleCreateLocation = () => {
    const id = `create-location-${Date.now()}`;
    dispatch(addTab({ id, name: "Create Location", contentType: "createLocation", isDynamic: true, createdAt: Date.now() }));
    dispatch(setActiveTab({ module: moduleName, index: tabs.length }));
  };

  const handleBulkUpdate = () => {
    const id = `bulk-update-locations-${Date.now()}`;
    dispatch(addTab({ id, name: "Bulk Update", contentType: "bulkUpdateLocations", isDynamic: true, createdAt: Date.now() }));
    dispatch(setActiveTab({ module: moduleName, index: tabs.length }));
  };


  return (
    <div className="p-fluid-1 shadow-md flex flex-col flex-1 h-full min-h-0 overflow-hidden">

      {/* Top Search Bar — only shown on the default Locations tab */}
      {activeTab < defaultTabsCount && (
        <div className="flex flex-wrap justify-between items-center rounded-md ml-[2] p-fluid-1">
          <div className="flex flex-wrap items-center gap-2">

            {/* Search Box */}
            <div className="relative flex items-center border border-gray-300 dark:border-acs-dark-border
                            bg-white dark:bg-acs-dark-surface rounded-full px-3 py-1.5 w-80
                            transition-none">
              <input
                type="text"
                placeholder="Search Locations"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full outline-none text-fluid-sm text-gray-800 dark:text-acs-dark-text
                           placeholder-gray-400 dark:placeholder-acs-dark-subtext bg-transparent"
              />
              <span className="absolute right-3 text-gray-500 dark:text-acs-dark-subtext">
                <FiSearch size={18} />
              </span>
            </div>

            {/* Total Locations Count */}
            <span className="text-gray-500 text-fluid-sm font-semibold text-acs-light-text dark:text-acs-dark-text">
              {totalLocations} locations
            </span>
          </div>

          <div className="flex items-center gap-fluid-2">
            <Button
              text="Bulk Update"
              variant="outline"
              onClick={handleBulkUpdate}
              className="!border-2 !border-acs-primary-navy !text-acs-primary-navy hover:!bg-white/70
                         dark:!border-acs-dark-border dark:!text-acs-dark-text dark:hover:!bg-acs-dark-hover/40"
            />
            <Button
              text="Create Location"
              onClick={handleCreateLocation}
              backgroundColor="#223688"
              textColor="white"
              fontSize="14px"
              padding="10px 18px"
              borderRadius="24px"
            />
          </div>

        </div>
      )}

      {/* Tabs */}
      <div className="flex-1 mt-fluid-2 min-h-0 flex flex-col scrollbar-hide">
        <Tabs
          moduleName={moduleName}
          tabs={tabs.map((tab) => tab.name)}
          tabContents={tabs.map((tab) => {
            if (tab.contentType === "locationView") {
              return (
                <ViewLocation
                  key={tab.id}
                  location={tab.data}
                />
              );
            }
            if (tab.contentType === "createLocation") {
              return (
                <CreateLocationTab
                  key={tab.id}
                  onClose={() => handleRemoveTab(tabs.findIndex((t) => t.id === tab.id))}
                  onSuccess={() => notify.success("Location created")}
                />
              );
            }
            if (tab.contentType === "bulkUpdateLocations") {
              return (
                <BulkUpdateLocationsTab
                  key={tab.id}
                  onClose={() => handleRemoveTab(tabs.findIndex((t) => t.id === tab.id))}
                />
              );
            }

            // Default "locations" tab renders the table
            return (
              <LocationsTable
                key="locations"
                searchQuery={searchQuery}
                setTotalLocations={setTotalLocations}
              />
            );
          })}
          activeTab={activeTab}
          onTabChange={(index) =>
            dispatch(setActiveTab({ module: moduleName, index }))
          }
          isDeletable={tabs.map((_, index) => index >= defaultTabsCount)}
          onRemoveTab={handleRemoveTab}
          aria-label="Locations tabs"
        />
      </div>
    </div>
  );
};

export default LocationsDetails;
